import { Modal } from "antd";
import { useState, useCallback } from "react"

export const useModalBase = (content, title = "title-modal", width = null) => {
    const [opened, setOpened] = useState(false);
    const open = useCallback(() => { setOpened(true); }, []);
    const close = useCallback(() => { setOpened(false); }, []);

    return {
        open,
        close,
        contextModal: (
            <Modal
                title={title}
                open={opened}
                onCancel={close}
                footer={null}
            >
                {content}
            </Modal>
        )
    }
}
